<template>
  <div class="login">
    <aside class="login-arte">
      <div class="arte-topo">
        <img src="@/assets/loginimg.png" alt="" class="arte-logo">
        <span class="arte-marca">Clockin</span>
      </div>

      <div class="arte-meio">
        <h1>Ponto eletrônico em conformidade, do app ao relógio da obra.</h1>
        <ul>
          <li><i class="bi bi-shield-check"></i> REP-P conforme a Portaria MTP nº 671/2021</li>
          <li><i class="bi bi-phone"></i> Aplicativo, WhatsApp e relógio itinerante com reconhecimento facial</li>
          <li><i class="bi bi-file-earmark-lock"></i> AFD, AEJ e espelho de ponto prontos para a fiscalização</li>
        </ul>
      </div>

      <div class="arte-relogio" aria-hidden="true">
        <span class="hora">{{ hora }}</span>
        <span class="data">{{ data }}</span>
      </div>
    </aside>

    <main class="login-form">
      <form class="caixa" @submit.prevent="logar">
        <img src="@/assets/loginimg.png" alt="Clockin" class="logo-mobile">
        <h2>Entrar no painel</h2>
        <p class="sub">Acesse com o código da sua empresa e seu usuário.</p>

        <label for="lg-empresa">Código da empresa</label>
        <div class="campo">
          <i class="bi bi-building"></i>
          <input id="lg-empresa" v-model.trim="empresa" inputmode="numeric" autocomplete="organization" placeholder="Ex.: 1" required>
        </div>

        <label for="lg-usuario">Usuário</label>
        <div class="campo">
          <i class="bi bi-person"></i>
          <input id="lg-usuario" v-model.trim="usuario" autocomplete="username" placeholder="seu.login" required>
        </div>

        <label for="lg-senha">Senha</label>
        <div class="campo">
          <i class="bi bi-lock"></i>
          <input id="lg-senha" v-model="senha" :type="verSenha ? 'text' : 'password'" autocomplete="current-password" placeholder="••••••" required>
          <button type="button" class="ver" @click="verSenha = !verSenha" :aria-label="verSenha ? 'Ocultar senha' : 'Mostrar senha'">
            <i :class="verSenha ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
          </button>
        </div>

        <div class="lembrar">
          <input id="lg-lembrar" type="checkbox" v-model="lembrar">
          <label for="lg-lembrar">Lembrar código da empresa e usuário</label>
        </div>

        <p v-if="erro" class="erro" role="alert"><i class="bi bi-exclamation-circle"></i> {{ erro }}</p>

        <button class="entrar" type="submit" :disabled="carregando">
          <span v-if="carregando" class="spinner-border spinner-border-sm"></span>
          <span v-else>Entrar</span>
        </button>

        <router-link to="/ponto-itinerante" class="link-relogio">
          <i class="bi bi-tablet"></i> Usar este aparelho como relógio de ponto
        </router-link>
      </form>
      <p class="rodape">Clockin Agente · Registro eletrônico de ponto via programa (REP-P)</p>
    </main>
  </div>
</template>

<script>
import util from '@/util'

export default {
  name: 'TelaLogin',
  data() {
    return {
      empresa: '',
      usuario: '',
      senha: '',
      lembrar: true,
      verSenha: false,
      carregando: false,
      erro: '',
      hora: '',
      data: '',
      timer: null,
    }
  },
  mounted() {
    try {
      const salvo = JSON.parse(localStorage.getItem('clockin_login') || '{}')
      this.empresa = salvo.empresa || ''
      this.usuario = salvo.usuario || ''
    } catch (e) { /* sem dados salvos */ }
    this.tique()
    this.timer = setInterval(this.tique, 1000)
    this.$nextTick(() => {
      const alvo = this.empresa ? (this.usuario ? 'lg-senha' : 'lg-usuario') : 'lg-empresa'
      const el = document.getElementById(alvo)
      if (el) el.focus()
    })
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    tique() {
      const d = new Date()
      this.hora = d.toLocaleTimeString('pt-BR')
      this.data = d.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' })
    },
    async logar() {
      this.erro = ''
      if (!/^\d+$/.test(this.empresa)) { this.erro = 'O código da empresa deve conter apenas números.'; return }
      this.carregando = true
      try {
        const resp = await util.reqaxios([
          { parametro: 'op', valor: 'logar' },
          { parametro: 'idempresa', valor: this.empresa },
          { parametro: 'dadoslogin', valor: JSON.stringify({ usuario: this.usuario, senha: this.senha }) },
        ], 'post', util.servidor + '/controller/rotinalogin.php')
        const d = resp.data
        if (d && d.msg === 0 && d.token) {
          if (this.lembrar) localStorage.setItem('clockin_login', JSON.stringify({ empresa: this.empresa, usuario: this.usuario }))
          else localStorage.removeItem('clockin_login')
          localStorage.setItem('dadosusuario', JSON.stringify(d))
          this.$store.commit('definelogin', d)
          this.$emit('logado', d)
        } else {
          this.erro = typeof d === 'string' ? d.replace(/^E - /, '') : String((d && d.msg) || 'Não foi possível entrar.').replace(/^I - /, '')
        }
      } catch (e) {
        this.erro = 'Não foi possível conectar ao servidor. Verifique sua internet e o código da empresa.'
      } finally {
        this.carregando = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.login {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(380px, 46%) 1fr;
  background: var(--ck-fundo);
}

/* ---------- painel da marca ---------- */
.login-arte {
  position: relative;
  color: #fff;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    linear-gradient(160deg, rgba(10, 52, 46, .92) 0%, rgba(19, 83, 74, .86) 55%, rgba(19, 83, 74, .70) 100%),
    url('@/assets/side.jpg') center / cover no-repeat;
  overflow: hidden;
}
.arte-topo { display: flex; align-items: center; gap: 12px; }
.arte-logo { width: 46px; height: 46px; border-radius: 12px; background: #fff; padding: 3px; }
.arte-marca { font-size: 1.35rem; font-weight: 700; letter-spacing: .01em; }
.arte-meio h1 { font-size: clamp(1.6rem, 2.4vw, 2.3rem); font-weight: 700; line-height: 1.2; max-width: 520px; margin-bottom: 28px; }
.arte-meio ul { list-style: none; padding: 0; margin: 0; display: grid; gap: 14px; max-width: 480px; }
.arte-meio li { display: flex; gap: 12px; align-items: flex-start; font-size: .98rem; color: rgba(255, 255, 255, .9); }
.arte-meio li i { font-size: 1.15rem; color: var(--ck-acento); margin-top: 1px; }
.arte-relogio { display: flex; flex-direction: column; }
.arte-relogio .hora { font-size: 2.6rem; font-weight: 300; font-variant-numeric: tabular-nums; letter-spacing: .02em; }
.arte-relogio .data { color: rgba(255, 255, 255, .75); }
.arte-relogio .data::first-letter { text-transform: uppercase; }

/* ---------- formulário ---------- */
.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
}
.caixa {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 20px;
  padding: 36px 32px 28px;
  box-shadow: var(--ck-sombra);
}
.logo-mobile { display: none; width: 64px; margin: 0 auto 12px; }
h2 { font-size: 1.45rem; font-weight: 700; margin: 0 0 4px; }
.sub { color: var(--ck-texto-2); margin-bottom: 24px; font-size: .9rem; }
label { display: block; font-size: .78rem; font-weight: 600; color: var(--ck-texto-2); margin-bottom: 6px; }
.campo {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid var(--ck-borda);
  border-radius: 12px;
  margin-bottom: 16px;
  background: #fff;
  transition: border-color .15s, box-shadow .15s;
}
.campo:focus-within { border-color: var(--ck-primaria-2); box-shadow: 0 0 0 3px rgba(19, 83, 74, .14); }
.campo > i { padding: 0 4px 0 14px; color: var(--ck-texto-2); }
.campo input { flex: 1; border: 0; outline: 0; height: 46px; padding: 0 12px 0 8px; font-size: .95rem; background: transparent; min-width: 0; }
.ver { border: 0; background: transparent; color: var(--ck-texto-2); padding: 0 14px; height: 46px; }
.lembrar { display: flex; align-items: center; gap: 8px; margin: -2px 0 18px; }
.lembrar input { accent-color: var(--ck-primaria); width: 16px; height: 16px; }
.lembrar label { margin: 0; font-weight: 500; font-size: .85rem; }
.erro { background: #fdecea; color: #9b2c20; border-radius: 10px; padding: 10px 12px; font-size: .86rem; display: flex; gap: 8px; }
.entrar {
  width: 100%; height: 48px; border: 0; border-radius: 12px;
  background: var(--ck-primaria); color: #fff; font-weight: 700; font-size: 1rem;
  transition: background .15s, transform .05s;
}
.entrar:hover:not(:disabled) { background: var(--ck-primaria-2); }
.entrar:active { transform: translateY(1px); }
.entrar:disabled { opacity: .75; }
.link-relogio { display: flex; justify-content: center; gap: 8px; margin-top: 18px; font-size: .86rem; text-decoration: none; color: var(--ck-primaria); font-weight: 600; }
.rodape { color: var(--ck-texto-2); font-size: .78rem; margin-top: 18px; text-align: center; }

@media (max-width: 860px) {
  .login { grid-template-columns: 1fr; }
  .login-arte { display: none; }
  .logo-mobile { display: block; }
  .caixa { padding: 28px 20px; }
  h2, .sub { text-align: center; }
}
</style>
